export function throttle(fn, delay = 300) {
    let timer = null;
    let lastTime = 0;
  
    const throttled = function (...args) {
      const now = Date.now();
      const remaining = delay - (now - lastTime);
  
      if (remaining <= 0) {
        // 立即执行
        fn.apply(this, args);
        lastTime = now;
      } else if (!timer) {
        // 设置尾部执行
        timer = setTimeout(() => {
          fn.apply(this, args);
          lastTime = Date.now();
          timer = null;
        }, remaining);
      }
    };
  
    // 添加取消方法
    throttled.cancel = () => {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    };
  
    return throttled;
  }